import React from 'react';
import type { PortfolioProject } from '../data/portfolio';

type PortfolioMediaProps = {
  project: Pick<PortfolioProject, 'thumbnail' | 'thumbnailFit' | 'title' | 'date' | 'scope'>;
  className?: string;
};

const PortfolioMedia: React.FC<PortfolioMediaProps> = ({ project, className = '' }) => {
  if (project.thumbnail) {
    const fitClass = project.thumbnailFit === 'contain' ? 'bg-slate-950 object-contain' : 'object-cover';
    return <img src={project.thumbnail} alt={`${project.title} 대표 이미지`} className={`${fitClass} ${className}`} />;
  }

  return (
    <div className={`flex flex-col justify-between bg-slate-950 p-6 text-white ${className}`} aria-label={`${project.title} 프로젝트 아카이브 커버`}>
      <p className="text-[11px] font-semibold tracking-[0.2em] text-white/55">PROJECT ARCHIVE</p>
      <p className="max-w-md break-keep text-xl font-semibold leading-snug text-white md:text-2xl">{project.title}</p>
      <div className="flex items-end justify-between gap-4 border-t border-white/15 pt-4 text-xs text-white/60">
        <span className="font-semibold tracking-[0.16em]">{project.date.slice(0, 4)}</span>
        <span className="max-w-[70%] text-right leading-5">{project.scope}</span>
      </div>
    </div>
  );
};

export default PortfolioMedia;
